// import { notification } from 'antd'
import { all, takeEvery, put, call } from 'redux-saga/effects'
import * as partnerProviders from 'services/partner'
import actions from './actions'
import menuActions from '../menu/actions'

export function* SHOW_PARTNER({ payload }) {
  yield put({
    type: 'partner/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const response = yield call(partnerProviders.showPartners, payload.businessCode)
  if (response) {
    const { partner, images } = response
    yield put({
      type: 'partner/SET_STATE',
      payload: {
        partner,
        images,
        redirectUrl: payload.redirectUrl,
      },
    })
  }
  yield put({
    type: 'partner/SET_STATE',
    payload: {
      loading: false,
    },
  })
  yield put({ type: menuActions.REFRESH_MENU })
}

export function* SHOW_PARTNER_GOOGLE_BUSINESS_ACCOUNTS({ payload }) {
  yield put({
    type: 'partner/SET_GOOGLE_ACCOUNT_STATE',
    payload: {
      loading: true,
    },
  })
  const response = yield call(
    partnerProviders.showPartnerGoogleBusinessAccounts,
    payload.businessCode,
  )
  if (response) {
    const { accounts } = response
    yield put({
      type: 'partner/SET_GOOGLE_ACCOUNT_STATE',
      payload: {
        data: accounts,
      },
    })
  }
  yield put({
    type: 'partner/SET_GOOGLE_ACCOUNT_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* CONNECT_PARTNER({ payload }) {
  yield put({
    type: 'partner/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const response = yield call(
    partnerProviders.connectPartner,
    payload.businessCode,
    payload.deviceName,
  )
  if (response) {
    const { redirect_url: redirectUrl } = response
    yield put({
      type: 'partner/SHOW_PARTNER',
      payload: {
        businessCode: payload.businessCode,
        redirectUrl,
      },
    })
  }
  yield put({
    type: 'partner/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* DISCONNECT_PARTNER({ payload }) {
  yield put({
    type: 'partner/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const response = yield call(
    partnerProviders.disconnectPartner,
    payload.businessCode,
    payload.deviceName,
  )
  if (response) {
    yield put({
      type: 'partner/SHOW_PARTNER',
      payload: {
        businessCode: payload.businessCode,
      },
    })
  }
  yield put({
    type: 'partner/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.SHOW_PARTNER, SHOW_PARTNER),
    takeEvery(actions.SHOW_PARTNER_GOOGLE_BUSINESS_ACCOUNTS, SHOW_PARTNER_GOOGLE_BUSINESS_ACCOUNTS),
    takeEvery(actions.CONNECT_PARTNER, CONNECT_PARTNER),
    takeEvery(actions.DISCONNECT_PARTNER, DISCONNECT_PARTNER),
  ])
}
